module.exports = __webpack_public_path__ + "img/area_25.aff33cab.svg";